import { useEffect } from 'react';
import { Outlet, Navigate } from 'react-router';
import { useAuthStore } from '../../store/authStore';
import { useThemeStore } from '../../store/themeStore';
import AuraOrb from '../effects/AuraOrb';

export default function AuthLayout() {
  const { isAuthenticated, isLoading, checkAuth } = useAuthStore();
  const { theme } = useThemeStore();

  // Check auth status on mount
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  // Match aura variant to theme
  const auraVariant = theme === 'golden-bull' ? 'gold'
    : theme === 'cyber-purple' ? 'purple'
    : theme === 'ice' ? 'cyan'
    : 'multi';

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-bg-primary">
        <AuraOrb variant={auraVariant} />
        <div className="relative z-10 animate-spin w-8 h-8 border-2 border-accent-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen bg-bg-primary relative overflow-hidden">
      {/* Aura background effect - living AI */}
      <AuraOrb variant={auraVariant} />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex items-center justify-center p-4">
        <Outlet />
      </div>
    </div>
  );
}
